export default "__VITE_ASSET__CBCmdnUj__"